"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetReservationCache = exports.orgNotaryHoursV2 = exports.orgNotaryHours = exports.getSchedule = exports.getReservations = exports.getPosition = exports.downloadDocument = exports.downloadDeed = exports.disconnect = exports.createReservation = exports.connect = exports.cancelReservation = exports.cancel = exports.cacheReservation = exports.accept = exports.RESET_RESERVATION_CACHE = exports.ORG_NOTARYHOURS = exports.GET_SCHEDULE = exports.GET_RESERVATIONS = exports.GET_POSITION = exports.DOWNLOAD_DOCUMENT = exports.DOWNLOAD_DEED = exports.DISCONNECT = exports.DELETE_RESERVATION = exports.CREATE_RESERVATION = exports.CONNECT = exports.CANCEL = exports.CACHE_RESERVATION = exports.ACCEPT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var GET_POSITION = 'ENOTARY_GET_POSITION';
exports.GET_POSITION = GET_POSITION;
var CONNECT = 'ENOTARY_CONNECT';
exports.CONNECT = CONNECT;
var CANCEL = 'ENOTARY_CANCEL';
exports.CANCEL = CANCEL;
var DOWNLOAD_DOCUMENT = 'ENOTARY_DOWNLOAD_DOCUMENT';
exports.DOWNLOAD_DOCUMENT = DOWNLOAD_DOCUMENT;
var DOWNLOAD_DEED = 'ENOTARY_DOWNLOAD_DEED';
exports.DOWNLOAD_DEED = DOWNLOAD_DEED;
var DISCONNECT = 'ENOTARY_DISCONNECT';
exports.DISCONNECT = DISCONNECT;
var ACCEPT = 'ENOTARY_ACCEPT';
exports.ACCEPT = ACCEPT;
var GET_SCHEDULE = 'ENOTARY_GET_SCHEDULE';
exports.GET_SCHEDULE = GET_SCHEDULE;
var GET_RESERVATIONS = 'ENOTARY_GET_RESERVATIONS';
exports.GET_RESERVATIONS = GET_RESERVATIONS;
var CREATE_RESERVATION = 'ENOTARY_CREATE_RESERVATION';
exports.CREATE_RESERVATION = CREATE_RESERVATION;
var DELETE_RESERVATION = 'ENOTARY_DELETE_RESERVATION';
exports.DELETE_RESERVATION = DELETE_RESERVATION;
var CACHE_RESERVATION = 'ENOTARY_CACHE_RESERVATION';
exports.CACHE_RESERVATION = CACHE_RESERVATION;
var RESET_RESERVATION_CACHE = 'ENOTARY_RESET_RESERVATION_CACHE';
exports.RESET_RESERVATION_CACHE = RESET_RESERVATION_CACHE;
var ORG_NOTARYHOURS = 'ORG_NOTARYHOURS';
exports.ORG_NOTARYHOURS = ORG_NOTARYHOURS;
var CONTEXT = '/enotary/secure/api/v1';
var CONTEXT_V2 = '/enotary/secure/api/v2';
var NOTARY_SESSION = '/notarysession';
var NOTARY_SCHEDULING = '/notaryschedule';

var getPosition = function getPosition() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_POSITION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SESSION, "/queue"), null, null, false));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getPosition = getPosition;

var connect = function connect(applicationUuid) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPut)(CONNECT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SESSION, "/connect/application/").concat(applicationUuid)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.connect = connect;

var cancel = function cancel() {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxPut)(CONNECT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SESSION, "/cancel"), null, {
                overrideCancel: true
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * @deprecated See downloadDeed
 */


exports.cancel = cancel;

var downloadDocument = function downloadDocument(notarySessionUuid, documentUuid) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(DOWNLOAD_DOCUMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/document/").concat(notarySessionUuid, "/").concat(documentUuid), {
                responseType: 'arraybuffer'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.downloadDocument = downloadDocument;

var downloadDeed = function downloadDeed(documentUuid) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxGet)(DOWNLOAD_DEED, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/document/").concat(documentUuid), {
                responseType: 'arraybuffer'
              }));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
}; // { documentUuid, notarySessionDocumentParticipantUuid, accept }


exports.downloadDeed = downloadDeed;

var accept = function accept(data) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxPut)(ACCEPT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SESSION, "/accept"), data));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.accept = accept;
var disconnect = (0, _reduxActions.createAction)(DISCONNECT);
exports.disconnect = disconnect;

var getSchedule = function getSchedule() {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxGet)(GET_SCHEDULE, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SCHEDULING)));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};

exports.getSchedule = getSchedule;

var getReservations = function getReservations(applicationUuid) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxGet)(GET_RESERVATIONS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SCHEDULING, "/reservations/").concat(applicationUuid), null, {
                applicationUuid: applicationUuid
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
}; // { applicationUuid, time, phoneNumber }


exports.getReservations = getReservations;

var createReservation = function createReservation(data) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (0, _ajax.ajaxPost)(CREATE_RESERVATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SCHEDULING), data));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
}; // { applicationUuid, time }


exports.createReservation = createReservation;

var cancelReservation = function cancelReservation(data) {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(dispatch) {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (0, _ajax.ajaxDelete)(DELETE_RESERVATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SCHEDULING), {
                body: JSON.stringify(data)
              }));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};
/**
 * @deprecated
 *
 * @param {Object} data Data to pass to body
 * @param {String} data.state State for notary hours
 * @returns
 */


exports.cancelReservation = cancelReservation;

var orgNotaryHours = function orgNotaryHours(data) {
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(dispatch) {
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", (0, _ajax.ajaxPost)(ORG_NOTARYHOURS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT).concat(NOTARY_SCHEDULING, "/hours"), data));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
};

exports.orgNotaryHours = orgNotaryHours;

var orgNotaryHoursV2 = function orgNotaryHoursV2(data) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(dispatch) {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", (0, _ajax.ajaxPost)(ORG_NOTARYHOURS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT_V2).concat(NOTARY_SCHEDULING, "/hours"), data));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
};

exports.orgNotaryHoursV2 = orgNotaryHoursV2;
var cacheReservation = (0, _reduxActions.createAction)(CACHE_RESERVATION);
exports.cacheReservation = cacheReservation;
var resetReservationCache = (0, _reduxActions.createAction)(RESET_RESERVATION_CACHE);
exports.resetReservationCache = resetReservationCache;